export default {"src":"/_next/static/media/TDOC.791f0139.svg","height":18,"width":18};